import React, { useState, useEffect } from 'react';

var BannerAd = function BannerAd(_a) {
  var _b, _c;

  var ad = _a.ad,
      zoomLevel = _a.zoomLevel;
  var actions = ad.actions,
      image = ad.image;
  return React.createElement("a", {
    href: (_b = actions.web) === null || _b === void 0 ? void 0 : _b.url,
    target: (_c = actions.web) === null || _c === void 0 ? void 0 : _c.target,
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: image.url,
    alt: image.alt,
    style: {
      maxWidth: "100%",
      maxHeight: "".concat(image.size.height * zoomLevel, "px")
    }
  }));
};

var CampaignRenderer = function CampaignRenderer(_a) {
  var ads = _a.ads,
      zoomLevel = _a.zoomLevel,
      refresh = _a.refresh;

  var _b = useState(Math.floor(Math.random() * ads.length)),
      currentAdIndex = _b[0],
      setCurrentAdIndex = _b[1];

  useEffect(function () {
    var intervalId = setInterval(function () {
      setCurrentAdIndex(function (prevIndex) {
        return (prevIndex + 1) % ads.length;
      });
    }, refresh * 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [ads.length]);
  var currentAd = ads[currentAdIndex];
  return React.createElement(BannerAd, {
    ad: currentAd,
    zoomLevel: zoomLevel
  });
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var CampaignLoader = function CampaignLoader(_a) {
  var metadataUrl = _a.metadataUrl,
      zoomLevel = _a.zoomLevel;

  var _b = useState(true),
      loading = _b[0],
      setLoading = _b[1];

  var _c = useState(null),
      metadata = _c[0],
      setMetadata = _c[1];

  useEffect(function () {
    var fetchData = function fetchData() {
      return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);

              return [4
              /*yield*/
              , fetch(metadataUrl)];

            case 1:
              response = _a.sent();
              return [4
              /*yield*/
              , response.json()];

            case 2:
              data = _a.sent();
              setMetadata(data);
              setLoading(false);
              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _a.sent();

              if (error_1.message !== 'test-error') {
                console.error('Error fetching metadata:', error_1);
              }

              setLoading(false);
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    fetchData();
  }, [metadataUrl]);

  if (loading) {
    return React.createElement("div", null, "Loading...");
  }

  if (!metadata) {
    return React.createElement("div", null, "Error loading metadata");
  }

  return React.createElement(CampaignRenderer, _assign({}, metadata, {
    zoomLevel: zoomLevel || 1
  }));
};

export { BannerAd, CampaignRenderer as Campaign, CampaignLoader };